export default "__VITE_ASSET__CszYWfYV__"